import get from 'lodash/get'

export const getEmailOptOutThankyouUrl = (channelData) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  const enabledFeature = channelData.features.find(({ name, enabled, value }) => name === 'emailOptOutThankyouUrl' && enabled === true && value !== 'noChannelUrl')
  if (!enabledFeature) {

    return false

  }

  return enabledFeature.value

}
